import React, { useState, useEffect } from 'react';
import './style.scss';
import BannerImg from "../../assets/images/placement/TransformBanner.webp";
import SecondaryBanner from '../../components/sections/SecondaryBanner';
import NEWS_UPDATES from '../../dummyData/NewsAndUpdate.json';

const TransformationNewArticles = () => {
  const [totalPages, setTotalPages] = useState(0);
  // const [itemsPerPage, setItemsPerPage] = useState(6);
  const [itemsPerPage] = useState(6);
  const [currPageNumber, setCurrPageNumber] = useState(1);
  const [currentPageData, setCurrentPageData] = useState([]);

  useEffect(() => {
    let pages = Math.ceil(NEWS_UPDATES.length / itemsPerPage);
    setTotalPages(pages);
    trimData(1, itemsPerPage);
  }, [itemsPerPage]);

  const trimData = (page, itemsPerPage) => {
    const fromInd = (page - 1) * itemsPerPage;
    const toInd = fromInd + itemsPerPage;
    const previousData = JSON.parse(JSON.stringify(NEWS_UPDATES));
    const trimData = previousData.slice(fromInd, toInd);
    setCurrentPageData(trimData);
  };

  const handlePageNoClick = (currPage) => {
    trimData(currPage, itemsPerPage)
    setCurrPageNumber(currPage);
  }

  const handlePrevNext = (type, currPage) => {
    if (type === "Prev") {
      if (currPage > 1) {
        trimData(currPage - 1, itemsPerPage)
        setCurrPageNumber(currPage - 1);
      }
    } else {
      if (currPage < totalPages) {
        trimData(currPage + 1, itemsPerPage)
        setCurrPageNumber(currPage + 1);
      }
    }
  }

  return (
    <>
      {/* Section: Banner */}
      <section>
        <SecondaryBanner
          imageUrl={BannerImg}
          title="Placements - Stories of transformation"
          desc="Inspiring Journeys: From Classroom to Career."
          themeColor="sh-contentimgsplit--red700-theme"
        />
      </section>

      {/* Section: Latest Stories */}
      <section className='nu-stories global-bglpink'>
        <div className='container'>
          <h1 className="global-heading">
            Media Spotlight: Inspiring Student Success Stories from Sitare University Program Placements
          </h1>

          <div className='nu-stories--list'>
            {currentPageData && currentPageData.length > 0 && currentPageData.map((item, index) => (
              <div key={index} className='nu-stories--item'>
                <div className='nu-stories--item-image'>
                  <img src={item?.image} alt="story" draggable='false' />
                </div>
                <div className='nu-stories--item-content'>
                  <h3 className="global-subheading nu-stories--item-title">{item?.title}</h3>
                  <p className="global-bodytext nu-stories--item-desc">
                    {item?.desc}
                  </p>
                  <button className='nu-stories--item-btn'>Read Full Article</button>
                </div>
              </div>
            ))}
          </div>

          <div className='global-pagination d-flex justify-content-center my-5'>
            <button className='me-3' onClick={() => handlePrevNext("Prev", currPageNumber)}>Previous</button>
            {totalPages && totalPages > 0 && [...Array(totalPages)].map((item, index) => (
              <div key={index} className={`global-pagination--number ${(currPageNumber === (index + 1)) && "active"}`} onClick={() => handlePageNoClick(index + 1)}>
                <p>{index + 1}</p>
              </div>
            ))}
            <button className='ms-3' onClick={() => handlePrevNext("Next", currPageNumber)}>Next</button>
          </div>
        </div>
      </section>
    </>
  )
}

export default TransformationNewArticles;